import React, { ReactNode } from 'react';

export type AuthStateType = {
  token: string | null;
  isAdmin: boolean;
  isFederal: boolean;
  isRepresentative: boolean;
  isExpert: boolean;
  isPovs: boolean;
  isNms: boolean;
  isSuperFederal: boolean;
};

export type AuthContextType = {
  state: AuthStateType;
  dispatch: React.Dispatch<AuthActions>;
};

export enum AuthActionType {
  Login = 'LOGIN',
  Logout = 'LOGOUT',
}

export type LogoutAction = {
  type: AuthActionType.Logout;
};

export type LoginAction = {
  type: AuthActionType.Login;
  payload: AuthStateType;
};

export type AuthActions = LogoutAction | LoginAction;

export type AuthProviderProps = {
  children: ReactNode;
};
